
import WDButton from '../button/wd-button';
import WDList from './wd-list';
import WDListFormItem from './wd-list-form-item';
import { WDRestObject } from '../../core/fetch/index.js';

export default class WDListForm extends WDList
{
	constructor(config) 
	{
		super(config);
		this.classList.add('wd-list-form');

		const rowCfg = config?.rows || {};

		if (rowCfg?.allowAdd) this.header.addButton({ 'fasIcon': 'plus' });
		if (rowCfg?.allowRemove) this.header.addButton({ 'fasIcon': 'trash' });

		if (rowCfg.buttons)
		{
			rowCfg.buttons.forEach(btnCfg => this.header.addButton(btnCfg));
		};

		//add the forms - they will be populated by the item data
		rowCfg.forms.forEach(formItem =>
		{
			const cell = this.header.add(formItem.label);
			if (formItem?.name) cell.classList.add(formItem?.name);
		});

		this.addNoResults();

		return this;
	};

	addNoResults()
	{
		const btn = new WDButton({ label: 'Add New Item', size: 'sm', theme: 'primary', fasIcon: 'plus' });
		btn.on('click', () => this.addFormItem());

		this.noResults.replaceChildren(btn);
	};

	// Item creation - can be overridden or handled via config
	createListItem(data)
	{
		// Default list item creation
		const item = new WDListFormItem(this.config.rows);
		this.setupItemModel(item,data);

		item.on('form:changed',evt => {
			this.trigger('form:changed',item);
		});

		return item;
	}

	updateListItem(item,data)
	{
		this.setupItemModel(item,data);
		return item;
	}

	setupItemModel(item, data)
	{
		if (data?.fetch)
		{
			item.model = data.fetch;
		}
		else if (data?.uri)
		{
			item.model = new WDRestObject(data.uri,data);
		} 
		else
		{
			item.model = data;
		} 

	};


	addFormItem(item)
	{
		const position = (item) ? item.index + 1 : this.items.length;

		if (this.fetch)
		{
			const p = new WDRestObject(this.fetch.getReqURI());
			this.model.insert(position, p);
		}
		else
		{
			this.model.insert(position, {});
		}

	};

	formHasValue(itemData)
	{
		// Handle null/undefined itemData
		if (!itemData || typeof itemData !== 'object') return false;

		return Object.values(itemData).some(val => {
			// Handle null/undefined values
			if (val == null) return false;
			
			// Handle arrays
			if (Array.isArray(val)) return val.length > 0;
			
			// Handle objects (check if it has meaningful content)
			if (typeof val === 'object') {
				// For objects, recursively check if they have values
				return this.formHasValue(val);
			}
			
			// Handle primitives (string, number, boolean)
			return String(val).trim().length > 0;
		});
	};

	get value()
	{
		const data = [];
		this.itemArray.forEach(item =>
		{
			const itemData = item.value;

			//ignore empty rows
			if (this.formHasValue(itemData)) data.push(itemData);
		});

		return data;
	};

	set value(vals)
	{
		this.reset();

		vals.forEach((val, idx) =>
		{
			const item = this.insert();
			item.value = val;
		});
	};

};

customElements.define('wd-list-form', WDListForm);
